import { CircularProgress, CircularProgressProps } from '@mui/material';

import { makeStyles } from 'tss-react/mui';

type LoaderProps = {
  disableBackground?: boolean;
  color?: CircularProgressProps['color'];
  size?: CircularProgressProps['size'];
  backgroundColor?: string;
  sx?: CircularProgressProps['sx'];
};

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    width: 76,
    height: 76,
    borderRadius: 76,
    backgroundColor: theme.palette.common.black,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export const Loader = (props: LoaderProps): JSX.Element => {
  const {
    disableBackground = false,
    color = 'primary',
    size = 44,
    backgroundColor,
    sx,
  } = props;
  const { classes } = useStyles();

  return (
    <div className={classes.root} style={{ backgroundColor }}>
      <div className={disableBackground ? undefined : classes.container}>
        <CircularProgress color={color} size={size} sx={sx} />
      </div>
    </div>
  );
};
